module.exports = __webpack_public_path__ + "static/img/logo_white_text.57297baf.png";